import { useQuery } from '@tanstack/react-query';
import parseHtmlToReact from 'html-react-parser';
import { Fragment } from 'react';
import { useParams } from 'react-router';

import FadeInAnimation from '../../utils/FadeInAnimation';
import { getLanguageCode } from '../../utils/utils';

import { getWebContainerQuery } from '@queries/editorial';
import ErrorBoundary from '@shared/ErrorBoundary';
import PictureHelper from '@shared/PictureHelper';

import * as styles from './styles.module.scss';

const imgFormats = ['0@s3', '440@s2', '960@s1'];

const SummaryCard = (story, i) => (
  <FadeInAnimation className={styles.summary__card} delay={250 * i}>
    <div className={styles.summary__image}>
      <PictureHelper
        wrapperClassName={styles.pflOverload}
        className={styles.summary__image}
        title={story.title}
        image={story.mainMedia?.image}
        formats={imgFormats}
      />
    </div>
    <div>
      <div className={styles.captionL}>{story.title}</div>
      <div className={styles['summary__card-description']}>{parseHtmlToReact(story.htmlDescription ?? '')}</div>
    </div>
  </FadeInAnimation>
);

const Summary = () => {
  const { locale } = useParams();
  const { data: stories } = useQuery(getWebContainerQuery('PLAYMAKERS.SUMMARY', getLanguageCode(locale)));

  if (!stories?.length) return null;

  return (
    <ErrorBoundary>
      <div id='about' className={styles.section}>
        <div className={styles.section__content}>
          <FadeInAnimation className={styles.summary__title} delay={250} offset={-100}>
            {stories[0].title}
          </FadeInAnimation>
          <div className={styles.summary__cards}>
            {stories.slice(1).map((s, i) => (
              <Fragment key={`summary_story_${s.id}`}>{SummaryCard(s, i)}</Fragment>
            ))}
          </div>
        </div>
      </div>
    </ErrorBoundary>
  );
};

export default Summary;
